import { useEffect, useRef, useState } from 'react';
import { usePageContent } from '@/context/ContentContext';

export default function FAQSection() {
  const c = usePageContent('home');
  const faqs = [
    { question: c.faq1_q, answer: c.faq1_a },
    { question: c.faq2_q, answer: c.faq2_a },
    { question: c.faq3_q, answer: c.faq3_a },
    { question: c.faq4_q, answer: c.faq4_a },
    { question: c.faq5_q, answer: c.faq5_a },
    { question: c.faq6_q, answer: c.faq6_a },
  ];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('animate-in');
              }, i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-white py-16 md:py-24">
      <div className="w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out rounded-xl overflow-hidden border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Collection%20of%20various%20personalized%20house%20number%20signs%20and%20door%20plates%20beautifully%20arranged%20on%20a%20light%20marble%20surface%2C%20different%20shapes%20and%20materials%20including%20acrylic%20and%20brass%2C%20warm%20studio%20lighting%2C%20professional%20flat%20lay%20product%20photography%20with%20soft%20shadows%20and%20clean%20minimal%20composition%2C%20premium%20home%20accessories%20display&width=800&height=800&seq=faq-img-2026&orientation=squarish"
              alt="Kolekcija personalizovanih kućnih brojeva"
              className="w-full h-auto object-cover"
            />
          </div>

          <div>
            <div className="mb-12">
              <h2 className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                {c.faq_heading}
              </h2>
              <p className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-100 ease-out text-base text-foreground-700 max-w-2xl">
                {c.faq_subtitle}
              </p>
            </div>

            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out border border-background-200 rounded-lg overflow-hidden"
                  style={{ transitionDelay: `${(index + 2) * 100}ms` }}
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left hover:bg-background-100 transition-colors"
                  >
                    <span className="font-label text-sm font-medium text-foreground-950 pr-4">{faq.question}</span>
                    <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-foreground-600" />
                    </div>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-48' : 'max-h-0'}`}
                  >
                    <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-700 leading-relaxed">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}
